import { render, staticRenderFns } from "./TermsDoc.vue?vue&type=template&id=0b9b9627"
import script from "./TermsDoc.vue?vue&type=script&lang=js"
export * from "./TermsDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports